export enum CredentialOverviewOption {
  Edit = 'Edit',
  Verify = 'Verify',
  Print = 'Print',
  Remove = 'Remove'
}
